import React from 'react';

export function BarChart({ data, valueKey = 'count', format = (v) => v, accent = 'var(--teal)' }) {
  const rows = Array.isArray(data) ? data : [];
  const max = Math.max(1, ...rows.map((r) => Number(r[valueKey]) || 0));
  if (!rows.length) return null;
  return (
    <div className="ah-bars" role="img" aria-label="chart">
      {rows.map((r) => {
        const v = Number(r[valueKey]) || 0;
        const pct = Math.max(3, Math.round((v / max) * 100));
        return (
          <div className="ah-bars-col" key={r.key || r.label} title={`${r.label} — ${format(v)}`}>
            <span className="ah-bars-val">{format(v)}</span>
            <div className="ah-bars-track">
              <div className="ah-bars-fill" style={{ height: `${pct}%`, background: accent }} />
            </div>
            <span className="ah-bars-label">{r.label}</span>
          </div>
        );
      })}
    </div>
  );
}

export function HBarChart({ data }) {
  const rows = (Array.isArray(data) ? data : []).filter((r) => r.count > 0);
  const max = Math.max(1, ...rows.map((r) => r.count));
  if (!rows.length) return null;
  return (
    <div className="ah-hbars">
      {rows.map((r) => (
        <div className="ah-hbars-row" key={r.label}>
          <span className="ah-hbars-label" title={r.label}>{r.label}</span>
          <div className="ah-hbars-track">
            <div className="ah-hbars-fill" style={{ width: `${Math.round((r.count / max) * 100)}%` }} />
          </div>
          <span className="ah-hbars-val">{r.count}</span>
        </div>
      ))}
    </div>
  );
}

const DONUT_COLORS = ['var(--teal)', 'var(--gold)'];

export function DonutChart({ data, labels }) {
  const rows = (Array.isArray(data) ? data : []).map((r) => ({ ...r, count: Number(r.count) || 0 }));
  const total = rows.reduce((s, r) => s + r.count, 0);
  if (!total) return null;
  const R = 46;
  const C = 2 * Math.PI * R;
  let offset = 0;
  const segs = rows.map((r, i) => {
    const frac = r.count / total;
    const seg = {
      key: r.key,
      dash: `${frac * C} ${C}`,
      offset: -offset * C,
      color: DONUT_COLORS[i % DONUT_COLORS.length],
      frac,
    };
    offset += frac;
    return seg;
  });
  return (
    <div className="ah-donut-wrap">
      <svg className="ah-donut" viewBox="0 0 120 120" role="img" aria-label="donut chart">
        <circle cx="60" cy="60" r={R} fill="none" stroke="rgba(12,30,60,0.07)" strokeWidth="16" />
        {segs.map((s) => (
          <circle
            key={s.key}
            cx="60"
            cy="60"
            r={R}
            fill="none"
            stroke={s.color}
            strokeWidth="16"
            strokeDasharray={s.dash}
            strokeDashoffset={s.offset}
            strokeLinecap="round"
            transform="rotate(-90 60 60)"
          />
        ))}
        <text x="60" y="64" textAnchor="middle" className="ah-donut-total">{total}</text>
      </svg>
      <ul className="ah-donut-legend">
        {segs.map((s) => (
          <li key={s.key}>
            <span className="ah-donut-dot" style={{ background: s.color }} />
            <span className="ah-donut-name">{labels?.[s.key] || s.key}</span>
            <strong>{Math.round(s.frac * 100)}%</strong>
          </li>
        ))}
      </ul>
    </div>
  );
}
